export default {
    logged: {
        title: 'Top 1 Diversified Tech Broker in Hong Kong',
        subTitle: 'One-Stop Global Investment',
        desc1: 'Under Fosun International (00656.HK), AI-powered WEB5 (WEB2+WEB3) integrated broker.',
        desc2: 'Licensed by Hong Kong SFC (Type 1, 2, 4, 6, 9), among first brokers with Hong Kong virtual asset trading license.',
        desc3: 'HK/US stocks, A-shares, crypto, funds, bonds, notes, RWA tokenized products and more.',
        ljkh3m: '3-Minute Express Account',
        zjjsqz: 'Final interpretation rights belong to Fosun Wealth Holdings',
        kh: 'Open Account',
        rj: 'Deposit',
        kt: 'Start Investing',
        lddesc1: 'One-stop global investment, full coverage of asset classes, Top 1 product variety among Hong Kong tech brokers.',
        lddesc2: 'Under Fosun International (00656.HK), AI-powered WEB5 (WEB2+WEB3) integrated broker.',
        lddesc3: 'Licensed by Hong Kong SFC (Type 1, 2, 4, 6, 9), among first brokers with Hong Kong virtual asset trading license.',
        user: 'User',
        getReward: 'Received $0 commission reward for account opening',
        gpmgqyj: 'HK/US Stocks/Options Permanent',
        yj: 'Commission',
        xsslyj1000hkd: 'Limited time: Get 1000+HKD rewards',
        star: 'Star',
    },
    pageTitle: 'Fosun Securities Account',
    title1: 'No Threshold',
    title2: '3-Minute Account',
    oneAccount: 'Invest Globally',
    advantage: 'Fosun Securities',
    advantage1: 'New User Bonus',
    des1: 'Open Account & Get Gifts',
    advantage2: 'Easy Trading',
    des2: 'Quick Order Change',
    advantage3: 'HK IPO',
    des3: 'Up to 33x Margin',
    advantage4: 'Dark Pool',
    des4: 'Faster Execution',
    advantage5: 'Margin Account',
    des5: 'Margin Trading',
    advantage6: 'Free Quotes',
    desLV2: 'HK LV2 Quotes',
    desLV1: 'US LV1 Quotes',
    hkLv2: 'HK LV2 Quotes',
    usLv1: 'US LV1 Quotes',
    usdes: 'US LV1 Stream',
    advantage7: 'Compliance',
    des7: 'SFC Licensed',
    advantage8: 'Trusted Brand',
    des8: 'Top 50 in China',
    btnText: 'Open Account',
    btnText2: 'Download',
    btnText3: 'Join',
    thsTip: 'Unfinished account. Use browser.',
    organTip: 'Account linked. Trading soon.',
    confirm: 'OK',
    cancel: 'Cancel',
    know: 'Got it',
    ndkhywc: 'Account Opened',
    hcydjwckhl: 'Almost done!<br/>Continue.',
    jvkh: 'Continue',
    isLogin: 'Login',
    tip: 'Notice',
    openAccountStrictContent: {
        confirmButtonText: 'Switch Method',
        tip1: 'No service for Mainland China.',
        tip2: 'No account for Mainland China.',
        tip3: 'Switch method will cancel application.',
        tip5: 'Complete in Xing Wealth App.',
        tip6: 'Enable location to proceed.',
        gotoAppBtn: 'Go to App',
        gotoSettingBtn: 'Settings',
        getAppLocationToastMessage: 'Fetching...',
    },
    mrStatus: {
        tip: {
            span1: 'System maintenance',
            span2: 'for better experience.',
            span3: 'Account, deposits, orders affected.',
        },
    },
    一站式全球财富管理平台: 'Global Wealth Platform',
    '覆盖港股、美股、沪深港通全球主要市场': 'HK, US, China Markets',
    '基金、债券、另类投资应有尽有': 'Funds, Bonds, Alternatives',
    存款方式多样化: 'Diverse Deposits',
    支持eDDA快速存款: 'eDDA Deposits',
    '支持转数快、银行转账等提供安全便捷等快速入金服务': 'FPS & Bank Transfers',
    tips: 'Tips',
    promptText: 'Unfinished corporate account. Complete on web.',
    openAccountLimitPopInfo: {
      title: 'Declaration for opening an account by mainland investors',
    },
    openProtocolContent: {
      first: 'I have read, understood and agree to',
      second:
        'the Declaration and Terms of Consent for Mainland China Investors Opening an Investment Account',
      third: 'all declaration contents and confirm that I am signing voluntarily',
    },
    agreementAndItems: {
      first: 'I agree to',
      second: 'the Consent to Electronic Signature',
      thirt:
        ', and shall use electronic means such as entering my trading password and one-time SMS verification code to',
      fourth:
        'the Declaration and Terms of Consent for Mainland China Investors Opening an Investment Account',
      fifth:
        'confirm and sign the documents. I understand that this electronic signing method complies with the provisions of the Hong Kong Electronic Transactions Ordinance (Cap. 553) and has the same legal effect as my handwritten signature',
    },
    signErrorTxt: 'Signing failed, please try again later',
}
